module.exports = __webpack_public_path__ + "static/media/Roots_alignment_modelling_external.c513e136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/Roots_alignment_modelling_external.svg
// module id = 944
// module chunks = 0